import {
  type AgentLoad,
  type CampaignSummary,
  type CouponSummary,
  type InvoiceListQuery,
  type InvoiceSummary,
  type OrderRefunds,
  type ProductSales,
  type RefundListQuery,
  type RefundSummary,
  type SubscriptionListQuery,
  type SubscriptionSummary,
  type SummaryQuery,
  type TicketListQuery,
  type TicketSummary,
  type WalletListQuery,
  type WalletSummary,
} from "@milqit/shared-types";

import { apiFetch, qs } from "./client";
import { type DeliveryQuery } from "./operations";

export async function getInvoiceSummary(
  query: SummaryQuery<InvoiceListQuery>,
): Promise<InvoiceSummary> {
  return apiFetch(`/admin/invoices/summary${qs({ ...query })}`);
}

/** Without `from`/`to`, the last 30 days (as the API does). */
export async function getWalletSummary(
  query: SummaryQuery<WalletListQuery> = {},
): Promise<WalletSummary> {
  return apiFetch(`/admin/wallet/summary${qs({ ...query })}`);
}

export async function getRefundSummary(
  query: SummaryQuery<RefundListQuery> = {},
): Promise<RefundSummary> {
  return apiFetch(`/admin/refunds/summary${qs({ ...query })}`);
}

export async function getOrderRefunds(orderId: string): Promise<OrderRefunds> {
  return apiFetch(`/admin/refunds/orders/${orderId}`);
}

export async function getTicketSummary(
  query: Omit<SummaryQuery<TicketListQuery>, "view" | "sort"> = {},
): Promise<TicketSummary> {
  return apiFetch(`/admin/tickets/summary${qs({ ...query })}`);
}

export async function getSubscriptionSummary(
  query: Omit<SummaryQuery<SubscriptionListQuery>, "status"> = {},
): Promise<SubscriptionSummary> {
  return apiFetch(`/admin/subscriptions/summary${qs({ ...query })}`);
}

export async function getCouponSummary(): Promise<CouponSummary> {
  return apiFetch("/admin/coupons/summary");
}

export async function getCampaignSummary(): Promise<CampaignSummary> {
  return apiFetch("/admin/campaigns/summary");
}

export async function getProductSales(productId: string): Promise<ProductSales> {
  return apiFetch(`/admin/orders/product-sales/${productId}`);
}

export async function getAgentLoad(day: DeliveryQuery["day"]): Promise<AgentLoad[]> {
  return apiFetch(`/admin/delivery-agents/load${qs({ day })}`);
}
